import React, { useRef, lazy } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
export const VisualBreak2 = () => {
  const ref = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], ['-10%', '10%']);
  return <section ref={ref} className="relative h-[35vh] md:h-[45vh] w-full overflow-hidden flex items-center justify-center bg-brand-darker" data-id="element-180">
      <motion.div style={{
      y
    }} className="absolute inset-0 w-full h-[120%] -top-[10%]" data-id="element-181">
        <img src="https://cdn.magicpatterns.com/uploads/izZHwqrQkC9cpfBcRpymy9/IMG_2742-PROOF-THOMAS-MASOTTI.jpg" alt="Séance de détatouage laser sur le dos d'un patient" className="w-full h-full object-cover grayscale-[30%]" loading="lazy" data-id="element-182" />
      </motion.div>
      <div className="absolute inset-0 bg-brand-dark/40 mix-blend-multiply" data-id="element-183"></div>

      <motion.p initial={{
      opacity: 0,
      y: 20,
      letterSpacing: '0.2em'
    }} whileInView={{
      opacity: 1,
      y: 0,
      letterSpacing: '0.6em'
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 1.5,
      ease: [0.16, 1, 0.3, 1]
    }} className="relative z-10 text-brand-light/60 text-xs md:text-sm uppercase font-medium text-center px-6" data-id="element-184">
        PRÉCISION · SÉCURITÉ · RÉSULTATS
      </motion.p>
    </section>;
};